import { render, staticRenderFns } from "./LyvHeader.vue?vue&type=template&id=167c63e2&"
import script from "./LyvHeader.vue?vue&type=script&lang=js&"
export * from "./LyvHeader.vue?vue&type=script&lang=js&"
import style0 from "./LyvHeader.vue?vue&type=style&index=0&id=167c63e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports